export const backendBaseUrl = "https://connect.eqarcom.ae";
export const dashboardBaseUrl = "";
